import { useState } from "react";

export default function ConfirmBbps(props) {

  const [errors, setErrors] = useState({});
  const [confirmAmount, setConfirmAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [mpin, setMpin] = useState("");

  const validate = (isBbps) => {
    if (isBbps == 1) {
      const newErrors = errorHandling('payNow');
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        props.billPayment(confirmAmount, mpin);
      }
    } else if(isBbps == 0) {
      const newErrors = errorHandling('transferNow');
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        props.transferNow(confirmAmount, mpin, remarks);
      }
    } else {
      const newErrors = errorHandling('claimNow');
      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        props.claimNow(mpin);
      }
    }
  }
  const errorHandling = (type) => {
    const errors = {};
    if (type === 'payNow') {
      if (!confirmAmount.trim()) {
        errors.confirmAmount = 'Amount is required';
      } else if (!mpin.trim()) {
        errors.mpin = 'Mpin is required';
      }
    } else if (type === 'transferNow') {
      if (!confirmAmount.trim()) {
        errors.confirmAmount = 'Amount is required';
      } else if (!mpin.trim()) {
        errors.mpin = 'Mpin is required';
      } else if (!remarks.trim()) {
        errors.mpin = 'Remarks is required';
      }
    } else if (type === 'claimNow') {
      if (!mpin.trim()) {
        errors.mpin = 'Mpin is required';
      }
    }
    return errors;
  };

  return (
    <div
      className="modal fade text-left show"
      id="verify_modal"
      tabIndex={-1}
      role="dialog"
      style={{ display: "block", paddingRight: 15, zIndex: 999, position: "fixed", inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        role="document"
      >
        {props.isBbps == 1 ? (
          <div className="modal-content">
            <div className="modal-header bg-danger">
              <h6 className="modal-title">{props.title}</h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => props.closeModal()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div
                  className="col-12 mg-t-10"
                  id="detail_bx"
                >
                  <div className="form-group">
                    <span>Biller Name</span>:&nbsp; {props.selectedBillerName}
                    <span className="float-right billerName" />
                    <br />
                    <span>Customer Name</span>:&nbsp;{props.accountHolderName}
                    <span className="accountHolderName float-right" /> <br />
                    <span>Due Date</span>:&nbsp;{props.dueDate} <span className="dueDate float-right" />
                    <br />
                    <span>Bill Date</span>:&nbsp;{props.billDate}
                    <span className="billDate float-right" />
                    <br />
                    <span>Bill Amount</span>:&nbsp;{props.billAmount}
                    <span className="float-right amount" />
                  </div>
                </div>
                <div
                  className="col-12 mt-2"
                  id="amount_bx"
                >

                  <div className="form-group mt-2">
                    <label htmlFor="amount">Amount</label>
                    <input
                      type="text"
                      id="amount"
                      placeholder="Amount"
                      className="form-control"
                      value={confirmAmount}
                      onChange={(e) => { setConfirmAmount(e.target.value) }}
                    />
                    {errors.confirmAmount && (
                      <span className="error-message">
                        {errors.confirmAmount}
                      </span>
                    )}
                  </div>
                  <div className="form-group mt-2">
                    <label htmlFor="amount">Mpin</label>
                    <input
                      type="password"
                      id="bbps_pin"
                      placeholder="Mpin"
                      className="form-control"
                      value={mpin}
                      onChange={(e) => { setMpin(e.target.value) }}
                    />
                    {errors.mpin && (
                      <span className="error-message">
                        {errors.mpin}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => validate(props.isBbps)}>
                Confirm
              </button>
              <button
                className="btn btn-default"
                onClick={() => props.closeModal()}
              >
                Close
              </button>
            </div>
          </div>
        ) : props.isBbps == 0 ? (
          <div className="modal-content">
            <div className="modal-header bg-success">
              <h6 className="modal-title text-white" id="myModalLabel33">{props.title}</h6>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.closeModal()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-12 mg-t-10">
                  <div className="form-group">
                    <span>User Name</span> <span className="float-right user_name">{props.userName}</span><br></br>
                    <span>User Mobile</span> <span className="user_mobile float-right">{props.userMobile}</span><br></br>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-12">
                  {errors.confirmAmount && (
                    <span className="error-message">
                      {errors.confirmAmount}
                    </span>
                  )}
                  {errors.mpin && (
                    <span className="error-message">
                      {errors.mpin}
                    </span>
                  )}
                  {errors.remarks && (
                    <span className="error-message">
                      {errors.remarks}
                    </span>
                  )}
                  <div className="form-group">
                    <label className="float-left mt-2">Transfer Amount:</label>
                    <input type="text" className="form-control float-right" placeholder="Enter Transfer Amount"
                      value={confirmAmount}
                      onChange={(e) => { setConfirmAmount(e.target.value) }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="float-left mt-2">Mpin:</label>
                    <input type="password" id="mpin" className="form-control float-right" placeholder="Enter Mpin"
                      value={mpin}
                      onChange={(e) => { setMpin(e.target.value) }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="float-left mt-2">Remark:</label>
                    <input type="text" id="remark" className="form-control float-right" placeholder="Enter Remark"
                      value={remarks}
                      onChange={(e) => { setRemarks(e.target.value) }}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => validate(props.isBbps)}>Confirm</button>
              <button className="btn btn-default" onClick={props.closeModal}>Close</button>
            </div>

          </div>
        ) : (
          <div className="modal-content">
            <div className="modal-header bg-success">
              <h6 className="modal-title text-white" id="myModalLabel33">{props.title}</h6>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.closeModal()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-12 mg-t-10">
                  <div className="form-group">
                    <span>Service</span> <span className="float-right user_name">{props.service}</span><br></br>
                    <span>Beneficiary Account</span> <span className="user_mobile float-right">{props.beneAccount}</span><br></br>
                    <span>Mobile</span> <span className="user_mobile float-right">{props.mobile}</span><br></br>
                    <span>UTR</span> <span className="user_mobile float-right">{props.utr}</span><br></br>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-12">
                  {errors.mpin && (
                    <span className="error-message">
                      {errors.mpin}
                    </span>
                  )}
                  <div className="form-group">
                    <label className="float-left mt-2">Amount:</label>
                    <input type="text" className="form-control float-right"
                      value={props.amount}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label className="float-left mt-2">Mpin:</label>
                    <input type="password" id="mpin" className="form-control float-right" placeholder="Enter Mpin"
                      value={mpin}
                      onChange={(e) => { setMpin(e.target.value) }}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => validate(props.isBbps)}>Confirm</button>
              <button className="btn btn-default" onClick={props.closeModal}>Close</button>
            </div>

          </div>
      )}
      </div>
    </div>
  );
}